module.exports = __webpack_public_path__ + "static/media/Original Korean - Lonely Struggle - Ch 30 and Epilogue.22ffa88d.txt";